import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CustomAttributeFilterOption, CustomAttributesFilter, FilterService} from "../../services/filter/filter.service";
import {CustomerService} from "../../services/customer/customer.service";
import {DoorType} from "../../models/door";

type CustomAttributeFilterOptionSelectable = CustomAttributeFilterOption & { selected?: boolean }

@Component({
  selector: 'custom-attributes-filter',
  templateUrl: './custom-attributes-filter.component.html',
  styleUrls: ['./custom-attributes-filter.component.scss'],
})
export class CustomAttributesFilterComponent implements OnInit {
  constructor(private readonly filterService: FilterService) {
  }

  @Output()
  public onValueChanged = new EventEmitter<Array<CustomAttributesFilter> | null>();

  filters: Array<CustomAttributeFilterOptionSelectable> = []

  async ngOnInit(): Promise<void> {
    const filter = this.filterService.getFilter()
    const filterOptions = this.filterService.getFilterOptions$().subscribe((filterOptions) => {
      if (!filter || !filterOptions) {
        return;
      }

      this.filters = filterOptions.customAttributesFilterOptions || []

      for (const f of this.filters) {
        f.selected = f.customAttribute.values.every((customAttributeValue) => filter.customAttributes?.find(filterCustomAttribute => filterCustomAttribute.attributeName === f.customAttribute.attributeName && filterCustomAttribute.values.includes(customAttributeValue)));
      }
    })

    this.filterService.getFilter$().subscribe((filter) => {
      if (!filter || !filterOptions) {
        return;
      }

      for (const f of this.filters) {
        f.selected = f.customAttribute.values.every((customAttributeValue) => filter.customAttributes?.find(filterCustomAttribute => filterCustomAttribute.attributeName === f.customAttribute.attributeName && filterCustomAttribute.values.includes(customAttributeValue)));
      }
    })
  }


  onSelectFilter(filter: CustomAttributeFilterOptionSelectable): void {
    filter.selected = !filter.selected;

    const filters: Array<CustomAttributesFilter> = []

    for (const f of this.filters.filter((f) => f.selected)) {

      const current = filters.find((filter) => filter.attributeName === f.customAttribute.attributeName);
      if (current) {
        const currentSet = new Set(current.values);
        for (const value of f.customAttribute.values) {
          currentSet.add(value);
        }
        current.values = Array.from(currentSet);
        continue;
      }

      filters.push({
        attributeName: f.customAttribute.attributeName,
        values: f.customAttribute.values,
      })
    }

    this.onValueChanged.emit(filters.length > 0 ? filters : null)
  }
}
